export const QA_NAME_LISTING_FORM_FLAT_FACTS = 'listingFormFlatFacts'
